import { Injectable } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, Validators } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class CommonUtilsService {
  otherCommoditySelected(isOptionSelected: boolean, formGroup): void {
    if (isOptionSelected) {
      formGroup.addControl('otherCommodities', new UntypedFormArray([]));
      formGroup.get('otherCommodities').push(new UntypedFormControl('', [Validators.required]));
    } else {
      formGroup.removeControl('otherCommodities');
    }
  }

  addOtherCommodityControl(formGroup): void {
    formGroup.addControl('otherCommodities', new UntypedFormArray([]));
    this.otherCommoditySelected(true, formGroup);
  }

  onAddOtherCommodity(formGroup, value?: any): void {
    formGroup.get('otherCommodities').push(new UntypedFormControl(value ? value : '', [Validators.required]));
  }

  onDeleteOtherCommodity(formGroup, index): void {
    formGroup.get('otherCommodities').removeAt(index);
    if (!formGroup.get('otherCommodities').controls.length) {
      const commodities = formGroup.get('commodities').value;
      const otherIndex = commodities.findIndex((c: any) => c === 'Other' || c.name === 'Other');
      if (otherIndex !== -1) {
        commodities.splice(otherIndex, 1);
        formGroup.get('commodities').patchValue(commodities);
      }
    }
  }

  formatSelectedCommodities(selectedCommodities: any[], requestedCommodities: any[], commList: any[]): void {
    requestedCommodities?.forEach(commodity => {
      const ind = commList.findIndex(element => element.name === commodity);
      if (ind !== -1) {
        commList[ind].selected = true;
        selectedCommodities.push(commList[ind]);
      }
    });
  }

  replaceZeroWithEmptyStr(limit: number | string): number | string {
    const formatLimit = limit
      ? (typeof (limit) === 'string' ? Number(limit)?.toFixed(0) : limit.toFixed(0))
      : limit;
    return (formatLimit === '0' || formatLimit === 0) ? '' : formatLimit;
  }

  fillCommodityDetailsInFormControl(processedPrefillInfo: any, parentFormGroup: any): void {
    const infoKeys = Object.keys(processedPrefillInfo);
    infoKeys?.forEach(productKey => {
      if (!parentFormGroup.get(productKey)) return;
      const infoArr = processedPrefillInfo[productKey];
      infoArr.forEach((data, idx) => {
        const selectedCommodities = [];
        const commodities = data.requestedCommodities || [];
        const productFormArray = parentFormGroup.get(productKey);
        const commList = productFormArray['controls'][idx].get('totalCommoditiesList').value;
        this.formatSelectedCommodities(selectedCommodities, commodities, commList);
        if (productFormArray) {
          productFormArray['controls'][idx].patchValue({
            commodities: selectedCommodities
          });
          if (data.requestedOtherCommodities?.length) {
            productFormArray['controls'][idx].addControl('otherCommodities', new UntypedFormArray([]));
            data.requestedOtherCommodities.forEach(element => {
              this.onAddOtherCommodity(productFormArray['controls'][idx], element);
            });
          }
        }
      });
    });
  }

  getApprovedCounterpartiesForDocuments(
    creditFacilityDetails: any,
    productConfigService: any,
    isLendingOrg: boolean
  ): { aorCounterparties: any[]; saCounterparties: any[] } {
    const aorCounterparties: any[] = [];
    const saCounterparties: any[] = [];

    if (isLendingOrg) {
      const buyerInformation = creditFacilityDetails?.buyer_information || {};

      Object.keys(buyerInformation).forEach(product => {
        const productTypeSnakeUC = productConfigService.getProductTypeAbbreviationSnakeUC(product);
        const isAorApplicable = productConfigService.getGivenKeyValueForCreditFacilityConfig(
          productTypeSnakeUC, 'approveConfig', 'assignmentOfReceivablesApplicable'
        );
        const isSaApplicable = productConfigService.getGivenKeyValueForCreditFacilityConfig(
          productTypeSnakeUC, 'approveConfig', 'supplierAgreement'
        );

        (buyerInformation[product] || []).forEach((buyer: any) => {
          const isValidStatus = buyer.status === 'Approved' || buyer.status === 'Terms Accepted'
            || buyer.status?.toLowerCase() === 'completed';

          if (isValidStatus) {
            if (isAorApplicable) {
              const existsInAor = aorCounterparties.some((cp) => cp.buyer_id === buyer.buyer_id);
              if (!existsInAor) {
                aorCounterparties.push(buyer);
              }
            }
            if (isSaApplicable) {
              const existsInSa = saCounterparties.some((cp) => cp.buyer_id === buyer.buyer_id);
              if (!existsInSa) {
                saCounterparties.push(buyer);
              }
            }
          }
        });
      });
    } else {
      const counterParties = creditFacilityDetails?.credit_facility_counter_parties || [];

      (counterParties || []).forEach((counterParty: any) => {
        const isAssignmentApplicable = productConfigService.getGivenKeyValueForCreditFacilityConfig(
          counterParty.product_type,
          'approveConfig',
          'assignmentOfReceivablesApplicable'
        );
        const isSupplierAgreementApplicable = productConfigService.getGivenKeyValueForCreditFacilityConfig(
          counterParty.product_type,
          'approveConfig',
          'supplierAgreement'
        );

        const isValidStatus = !counterParty.counter_party_status?.includes('Rejected')
          && counterParty.counter_party_status !== 'Inactive';

        if (isValidStatus) {
          if (isAssignmentApplicable) {
            const existsInAor = aorCounterparties.some(
              (cp) => cp.counter_party_id === counterParty.counter_party_id
            );
            if (!existsInAor) {
              aorCounterparties.push(counterParty);
            }
          }
          if (isSupplierAgreementApplicable) {
            const existsInSa = saCounterparties.some(
              (cp) => cp.counter_party_id === counterParty.counter_party_id
            );
            if (!existsInSa) {
              saCounterparties.push(counterParty);
            }
          }
        }
      });
    }

    return { aorCounterparties, saCounterparties };
  }

}
